<template>
<form @submit.prevent="emitSave" id="productlineAddEditDialog">
  <h4 class="mb-4">{{ 'ADD' | translate }}</h4>
<div class="alert alert-danger alert-dismissible mt-5" v-if="error" id="productlineAddEditDialog-errorDiv">
  {{ error | translate }}
  <button type="button" class="close" @click="dismissAlertError()" aria-label="Close" id="productlineAddEditDialog-closeButton">
    <span aria-hidden="true" id="productlineAddEditDialog-closeButton-span">&times;</span>
  </button>
</div>
  <div class="form-group" id="productlineAddEditDialog-formGroup-naam">
    <label>{{ 'Naam' | translate }} <span class="asterisk">*</span></label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="productline.name"
           required :disabled="!!edited"
           id="productlineAddEditDialog-formGroup-naam-input">
  </div>

  <div class="form-group" id="productlineAddEditDialog-formGroup-Omschrijving">
    <label>{{ 'Omschrijving' | translate }} <span class="asterisk">*</span></label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="productline.description"
           required
           id="productlineAddEditDialog-formGroup-Omschrijving-input">
  </div>
<div class="form-group" id="productlineAddEditDialog-formGroup-SubBranche" v-if="subBrancheOptions && subBrancheOptions.length">
  <label>{{ 'SubBranche' | translate }}</label>
  <select class="form-control form-control-sm"
          v-model="selectedSubBrancheId"
          id="productlineAddEditDialog-formGroup-SubBranche-input">
    <option value="" >{{ 'SELECT' | translate }}</option>
     <option v-for="sub in filteredSubBrancheOptions" :key="sub.id" :value="sub.id">
    {{ sub.description }}
  </option>
  </select>
</div>



<div class="form-group" id="productlineAddEditDialog-formGroup-Verrijking">
    <label>{{ 'Verrijking' | translate }} <span class="asterisk">*</span></label>
    <select class="form-control form-control-sm"
            v-model="productline.enrichment"
            required
            id="productlineAddEditDialog-formGroup-Verrijking-input">
      <option value="" disabled>{{ 'SELECT' | translate }}</option>
      <option value="VEHICLE_INFORMATION">{{ 'VEHICLE_INFORMATION' | translate }}</option>
      <option value="BUILDING_INFORMATION">{{ 'BUILDING_INFORMATION' | translate }}</option>
      <option value="NONE">{{ 'NONE' | translate }}</option>
    </select>
  </div>

  <div class="form-group" id="productlineAddEditDialog-formGroup-afdElement" v-if="productline.enrichment === 'VEHICLE_INFORMATION'">
    <label>{{ 'AFD element' | translate }}</label>
    <select class="form-control form-control-sm"
            v-model="productline.afdElement"
            required
            id="productlineAddEditDialog-formGroup-afdElement-input">
      <option value="" disabled>{{ 'SELECT' | translate }}</option>
      <option value="OB">OB</option>
      <option value="BF">BF</option>
      <option value="AA">AA</option>
      <option value="CR">CR</option>
    </select>
  </div>

  <div class="form-group" id="productlineAddEditDialog-formGroup-Enabled">
    <label>{{ 'Enabled' | translate }}</label>
    <input type="checkbox"
           class="form-control form-control-sm"
           v-model="productline.enabled"
           id="productlineAddEditDialog-formGroup-Enabled-input">
  </div>

  <div class="mt-4 text-right" id="productlineAddEditDialog-formGroup-buttons">

    <button class="btn btn-link" type="button"
            @click="emitClose"
            id="productlineAddEditDialog-closeButton"
    >{{ 'CLOSE' | translate }}</button>

    <button class="btn btn-primary"
            type="submit"
            :disabled="!isFormValid"
            id="productlineAddEditDialog-addButton"
    >{{ 'ADD' | translate }}</button>

  </div>
</form>
</template>

<script>
import GeneralConfigService from '../../../service/GeneralConfigService';

export default {
  props: ['edited', 'subBrancheOptions', 'existingProductlines'],
  data() {
    return {
      productline: {},
      selectedSubBrancheId: '',
      error: ''
    }
  },
  computed: {
    isFormValid() {
      return this.productline.name && this.productline.description;
    },
    filteredSubBrancheOptions() {
      if (!this.productline.name) return null;
      // Case-insensitive match
      return this.subBrancheOptions.filter(sub =>
        sub.branche &&
        sub.branche.toLowerCase().includes(this.productline.name.toLowerCase())
      );
    },
    isDuplicate() {
      // Check for duplicate naam + subBrancheId in existingProductlines
      if (!this.productline.name || !this.selectedSubBrancheId || !this.existingProductlines) return false;
      return this.existingProductlines.some(row =>
        row.name === this.productline.name &&
        row.subBranche &&
        row.subBranche.id === this.selectedSubBrancheId &&
        (!this.edited || row.id !== this.productline.id)
      );
    }
  },
  methods: {
    emitSave() {
      if (this.isDuplicate) {
        this.error = 'DUPLICATE_PRODUCTLINE';
        return;
      }
      this.productline.subBranche = this.subBrancheOptions.find(sub => sub.id === this.selectedSubBrancheId) || null;
      this.$emit(this.edited ? 'update' : 'save', this.productline);
      if (this.productline.enabled) {
        GeneralConfigService.addOrUpdateEnabledProductLine(this.productline);
      } else {
        GeneralConfigService.removeEnabledProductLine(this.productline);
      }
      this.productline = {};
      this.selectedSubBrancheId = '';
      this.error = '';
    },
    emitClose() {
      this.$emit('close');
      this.productline = {};
      this.selectedSubBrancheId = '';
      this.error = '';
    },
    dismissAlertError() {
      this.error = '';
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.productline = { ...newVal };
      this.selectedSubBrancheId = this.productline.subBranche ? this.productline.subBranche.id : '';
    }
  }
}
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/productline/ProductlineAddEditDialog.vue